import axios from "axios";
import qs from 'qs';


const bauAxiosObj = () => {
  let axiosConfig = {};

  axiosConfig.responseType = "json";
  axiosConfig.headers = {
    Pragma: "no-cache",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  axiosConfig.baseURL = process.env.REACT_APP_THREE_COM_DOMAIN + "/3Care/";

  if (process.env.REACT_APP_ENV == "DEV") {
    axiosConfig.auth = {
      username: "user",
      password: "3.comUXuat",
    };
  }

  axiosConfig.validateStatus = false;

  const axiosInstance = axios.create(axiosConfig);

  axiosInstance.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

const threePlusAxiosObj = () => {
  let axiosConfig = {};

  axiosConfig.responseType = "json";
  axiosConfig.headers = {
    Pragma: "no-cache",
    "Content-Type": "application/x-www-form-urlencoded",
  };

  axiosConfig.baseURL = process.env.REACT_APP_THREE_COM_DOMAIN + "/ThreePlus/";

  if (process.env.REACT_APP_ENV == "DEV") {
    axiosConfig.auth = {
      username: "user",
      password: "3.comUXuat",
    };
  }

  axiosConfig.validateStatus = false;

  const axiosInstance = axios.create(axiosConfig);

  axiosInstance.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

const bauJSONAxiosObj = () => {
  let axiosConfig = {};

  axiosConfig.responseType = "json";
  axiosConfig.headers = {
    Pragma: "no-cache",
    "Content-Type": "application/json",
  };

  axiosConfig.baseURL = process.env.REACT_APP_THREE_COM_DOMAIN + "/3Care/";

  if (process.env.REACT_APP_ENV == "DEV") {
    axiosConfig.auth = {
      username: "user",
      password: "3.comUXuat",
    };
  }

  axiosConfig.validateStatus = false;

  const axiosInstance = axios.create(axiosConfig);

  axiosInstance.interceptors.request.use(
    function(config) {
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async (response) => {
      return response;
    },
    async (error) => {
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default class BauUtil {
  static validateMobileNumberForExclusiveOffer = async (msisdn) => {
    const language = window.THREE_REACT_APP_GLOBAL.language == "en" ? "eng" : "chi";
    let responseObj = threePlusAxiosObj().post("validateMobileNumberForExclusiveOffer.do", qs.stringify({
      msisdn,
      language,
      campaignId:"ONLINE_ACQ"
    }));

    return responseObj;
  };

  static login = async (id, pw, lang) => {
    let responseObj = bauAxiosObj().post("verifyLogin.do", qs.stringify({
      lang,
      appId: 'appCSNew',
      action: 'login',
      isNew3APICall: 'true',
      mobileno:id,
      password:pw
    }));

    return responseObj;
  };

  static login = async (id, pw, otp, lang) => {
    let responseObj = bauAxiosObj().post("verifyLogin.do", qs.stringify({
      lang,
      appId: 'appCSNew',
      action: 'login',
      isNew3APICall: 'true',
      mobileno:id,
      password:pw,
      otp
    }));

    return responseObj;
  };

  static logout = async () => {
    let responseObj = bauAxiosObj().post("LogoutAPI.do");

    return responseObj;
  };

  static logout = async () => {
    let responseObj = bauAxiosObj().post("LogoutAPI.do");

    return responseObj;
  };

  static sendLoginOTP = async(id,password,lang) =>{
    let responseObj = bauJSONAxiosObj().post("SendLoginIdOTPAction.do", {
      id,
      lang,
      password
    });

    return responseObj;
  };

}